import NotFound from '../components/NotFound';

export default function Portfolio() {
  return <NotFound pageName="Portfolio" />;
}
